
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
// import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import { TextField } from "@mui/material";
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
// import { Document, Text, StyleSheet, View, Image } from '@react-pdf/renderer';
import * as moment from 'moment';
import certLogo from "assets/images/CertificateLogo.png";
import satyaLogo from "assets/images/CertificateLogoOld.png";
import shivajiMLogo from "assets/images/Ch.Shivaji_LOGO.png";
import { jsPDF } from 'jspdf';
import html2canvas from "html2canvas";
import * as service from '../../services/service';

function GenerateNFLSCertificate() {
    const [data, setData] = useState([{}]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const certificateId = JSON.parse(sessionStorage.getItem('CertificateId'));
    const certificateNumber = JSON.parse(sessionStorage.getItem('CertificateNumber'));
    const outwardNumber = JSON.parse(sessionStorage.getItem('OutwardNumber'));
    const issueDate = JSON.parse(sessionStorage.getItem('IssueDate'));
    const navigate = useNavigate();
    const params = useParams();

    const getRegistrationById = () => {
        setLoading(true);
        // const errs = {};        
        if (params.id > 0) {
            fetch(
                service.GET_NFLS_REGISTRATION_BY_ID,
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: JSON.stringify({
                        NFLSRegistrationId: params.id,
                    })
                })
                .then(res => res.json())
                .then(result => {
                    if (result.message.messageType === 'Success') {
                        setData(result);
                    }
                    else {
                        // eslint-disable-next-line
                        alert(result.message.message);
                    }
                });
        }
        setLoading(false);
    };

    useEffect(() => {
        if (params.id > 0) {
            getRegistrationById();
        }
    }, []);


    const submitHandler = e => {
        e.preventDefault();
        const errs = {};
        setLoading(true);
        const divToPrint = document.querySelector('#divForm');
        html2canvas(divToPrint).then(canvas => {
            const imgData = canvas.toDataURL('image/png');
            const imgWidth = 190;
            const pageHeight = 290;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            // eslint-disable-next-line new-cap
            const doc = new jsPDF('pt', 'mm');
            let position = 0;
            doc.addImage(imgData, 'PNG', 10, 0, imgWidth, imgHeight + 25, undefined, 'FAST');
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                doc.addPage();
                doc.addImage(imgData, 'PNG', 10, position, imgWidth, imgHeight + 25);
                heightLeft -= pageHeight;
            }
            // const doc1 = addWaterMark(doc);
            const blob = doc.output('blob');
            // doc.toBlob(blob => {
            const certFile = new File([blob], 'Certificate.pdf');
            const formData = new FormData();
            formData.append("NFLSRegistrationId", params.id ? params.id : null);
            formData.append("NFLSCertificateId", certificateId);
            formData.append("IssueDate", (new Date(issueDate)).toUTCString());
            formData.append("CertificateNumber", certificateNumber);
            formData.append("OutwardNumber", outwardNumber);
            formData.append("CertificateFile", certFile);
            formData.append("AddedBy", JSON.parse(window.sessionStorage.getItem('userData')).userId);
            fetch(
                service.ADD_UPDATE_NFLS_CERTIFICATE,
                {
                    method: 'POST',
                    headers: {
                        'XApiKey': JSON.parse(sessionStorage.getItem('userData')).apiKey
                    },
                    body: formData
                })
                .then(res => res.json())
                .then(result => {
                    if (result.messageType === 'Success') {
                        // eslint-disable-next-line
                        alert(result.message);
                        sessionStorage.setItem('CertificateNumber', null);
                        sessionStorage.setItem('IssueDate', null);
                        sessionStorage.setItem('OutwardNumber', null);
                        sessionStorage.setItem('CertificateId', null);
                        navigate('/nflsregistrations');
                    }
                    else if (result.messageType === 'Failed') {
                        // eslint-disable-next-line
                        alert(result.message);
                        sessionStorage.setItem('CertificateNumber', null);
                        sessionStorage.setItem('IssueDate', null);
                        sessionStorage.setItem('OutwardNumber', null);
                        sessionStorage.setItem('CertificateId', null);
                        navigate('/nflsregistrations');
                    }
                    else {
                        errs[".invalid"] = result.message.message;
                        setErrors(errs);
                    }
                });
        });
        // }, 'image/png')
        setLoading(false);
    }

    const backHandler = () => {
        navigate('/nflsregistrations');
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    NFLS Certificate
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <div id="divForm" width="100%">
                                    <br />
                                    <Table id="tblCertificate" style={{ "borderWidth": "5px", 'borderColor': "lightcoral", 'borderStyle': 'solid' }}>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center">
                                                <img src={satyaLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center" style={{ fontSize: '21px', fontWeight: 'bold', color: 'maroon' }}>
                                                Directorate of Tourism (DoT), Govt of Maharashtra
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center"><hr /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align="left">
                                                <img src={certLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                            <TableCell align="center" style={{ fontSize: '15px', fontWeight: 'bold', }}>
                                                HO: Sakhar Bhavan, 4th Floor, Plot No.230, Nariman Point, Mumbai - 400021.
                                                <br />
                                                Phone No:- 91-22-69107600
                                                <br />
                                                Email:- diot@maharashtratourism.gov.in
                                                <br />
                                                Website:- www.maharashtratourism.gov.in
                                            </TableCell>
                                            <TableCell align="right">
                                                <img src={shivajiMLogo} alt="Logo" height="100px" width="100px" />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="center"><hr /></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                {certificateNumber}
                                            </TableCell>
                                            <TableCell />
                                            <TableCell align="right" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Date : {moment(issueDate).format('DD-MM-YYYY')}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                To,
                                                <br />
                                                {data.applicantName},
                                                <br />
                                                {data.address},
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Sub: Permission for usage of Maharashtra Tourism logo for the {data.programName} scheduled to be held on {data.programPeriod} at {data.programAddress}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Sir,
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                Please refer to your proposal regarding non-financial support for the {data.programName} scheduled to be held on {data.programPeriod} at {data.programAddress}
                                                <br />
                                                You are permitted usage of the `Maharashtra Tourism` logo for the said Event. Attached are the logo guidelines to be followed. Failure to comply will result in strict action.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                i. Permission for use of `Maharashtra Tourism` logo for {data.programName}, scheduled to be held on {data.programPeriod} at {data.programAddress}.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                ii. Directorate of Tourism reserves the right to withdraw Permission for use of the `Maharashtra Tourism` logo, if at any point of time; it is felt; that the Event is not as per the ideology of DOT.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                iii. Usage of this logo will not involve have any financial implications.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                iv. The proposed design and layout of the promotional material with `Maharashtra Tourism` logo may be submitted to the Directorate of Tourism, prior to its finalization.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                v. `Maharashtra Tourism` logo should be prominently displayed in the promotional activities during the festival viz., Brochures, Kits, Flexi, Advertisement and Website related to the Promotion of the Exhibition.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                vi. The `Maharashtra Tourism` logo should be used only for promotion of the Event for which the Permission has been granted.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                vii. The organiser should promote minimum two Maharashtra Tourism destinations on its social Media platform.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                viii. VIP and VVIP passes will be allocated.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                ix. This letter is valid subject to all necessary clearances from the competent authorities under relevant provisions of law/rules in force and subject to necessary safety arrangements & precautions.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                x. The organizers shall bear sole and full responsibility for ensuring that there are no criminal offenses or legal/court claims of any kind related to the organization of the event or its sponsorship in the future. Should such a situation arise, the Directorate of Tourism, Tourism Department, Government of Maharashtra, will not be responsible under any circumstances. Furthermore, the said institution will not be extended any further cooperation regarding sponsorship.
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                xi. The organizers must take all necessary precautions regarding security at the event venue. The Directorate of Tourism will not be held responsible if any untoward incident occurs during the event.
                                                (As approved by Hon. Director)
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                xii. The organizer will be mandatorily required to submit an affidavit regarding clauses X and XI on a stamp paper of ₹500/- (Rupees Five Hundred Only).
                                                (As approved by Hon. Director)
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                xiii. Alcohol or any other intoxicating substances must not be displayed or sold during the said festival/event. If any such activity is found, the logo collaboration/approval granted for the festival/event will be cancelled immediately. Please take note of this.
                                                (As approved by Hon. Director)
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan="3" align="right" style={{ fontSize: '16px', fontWeight: 'bold' }}>
                                                <br />
                                                {JSON.parse(sessionStorage.getItem('userData')).userName}
                                                <br />
                                                {JSON.parse(sessionStorage.getItem('userData')).userRole}
                                                <br />
                                            </TableCell>
                                        </TableRow>
                                    </Table>
                                </div>
                                <Table>
                                    <TableRow>
                                        <TableCell>
                                            {loading ? <Oval
                                                heigth="20"
                                                width="20"
                                                color='grey'
                                                ariaLabel='loading'
                                            /> :
                                                <MDButton color="info" onClick={submitHandler}>
                                                    Save
                                                </MDButton>
                                            }
                                        </TableCell>
                                        <TableCell>
                                            <MDButton color="secondary" onClick={backHandler}>
                                                Back
                                            </MDButton>
                                        </TableCell>
                                    </TableRow>
                                </Table>
                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".error"]}</div>
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default GenerateNFLSCertificate;